import React from 'react'
import { PickingDiffFilter } from '../../../interfaces/PickingValidate/PickingDiffFilter'

interface ElementListProps<T> {
  children: (item: T) => React.ReactNode
  dir: 'horizontal' | 'vertical'
  dividers?: boolean
  items: T[]
  filters: PickingDiffFilter
  windowing?: boolean
}

interface IPositionInfo {
  positionId: string | number
  positionName: string
}

export const ElementList = <T extends IPositionInfo>({
  children,
  items,
  filters
}: ElementListProps<T>) => {
  let elements: JSX.Element[]
  if (filters.positionName !== '') {
    elements = items
      .filter((row) =>
        row.positionName
          .toLowerCase()
          .includes(filters.positionName.toLowerCase())
      )
      .map((item) => (
        <div key={item.positionId} className='item'>
          {children(item)}
        </div>
      ))
  } else {
    elements = items.map((item) => (
      <div key={item.positionId} className='item'>
        {children(item)}
      </div>
    ))
  }

  return <React.Fragment>{elements}</React.Fragment>
}
